var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormatIconDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 138,
    viewBox: "0 0 12 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(-675 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "FormatNumberGray",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(675 331)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "FormatNumberBlue",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(675 373)",
    fill: "#203250"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(675 415)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(675 457)",
    fill: "#bebebe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIconDot);
export default __webpack_public_path__ + "static/media/Format_Icon_dot.e8c014df.svg";
export { ForwardRef as ReactComponent };